import type { Room } from "@/types/property";

export const KEYNEST_DETAIL_FIELDS = [
  "keynest_pickup_code",
  "keynest_access_code",
  "keynest_opening_hours_weekdays",
  "keynest_opening_hours_saturday",
  "keynest_key_label",
] as const;

type KeynestDetailKey = (typeof KEYNEST_DETAIL_FIELDS)[number];

/**
 * Only the KeyNest detail fields the admin actually edited. keynest-checkin
 * rewrites these columns, so echoing unchanged values could overwrite a sync
 * that landed while the sheet was open.
 */
export function changedKeynestDetails(
  form: Record<KeynestDetailKey, string>,
  room: Pick<Room, KeynestDetailKey>
) {
  const patch: Partial<Record<KeynestDetailKey, string | null>> = {};
  for (const key of KEYNEST_DETAIL_FIELDS) {
    const next = form[key].trim() || null;
    const current = room[key]?.trim() || null;
    if (next !== current) patch[key] = next;
  }
  return patch;
}
